import { useFormik } from "formik";
import * as styles from './MessageEditor.module.less';
import { ButtonVariants, Icons, TromanButton } from "@/twapp/react/components/Buttons";
import { useNavigationLock } from "@/twapp/react/hooks/useTromanService";
import { MeetingMessage } from "@/twapp/objects/MeetingMessage";

export interface IMessageEditorForm {
    subject: string;
    message: string;
    notify: boolean;
    publish: boolean;
}

export interface IMessageEditorProps {
    form: IMessageEditorForm,
    message?: MeetingMessage,
    onSubmit: (form: IMessageEditorForm) => void;
    onCancel: () => void;
    onDelete?: () => void;
}

export const MessageEditor = (props: IMessageEditorProps) => {

    const form = useFormik<IMessageEditorForm>({
        initialValues: props.form,
        onSubmit: props.onSubmit,
    });

    useNavigationLock(form.dirty);
    
    const notificationTimestamp = props.message?.NotificationTimestamp;

    return (
        <div className={styles.messageEditor}>
            <form onSubmit={form.handleSubmit}>
                <div className="form-group">
                    <label className="control-label">Titel</label>
                    <input type="text" className="form-control input-sm" onChange={form.handleChange} onBlur={form.handleBlur} value={form.values.subject} name="subject" />
                    {form.errors.subject && <div id="feedback">{form.errors.subject}</div>}
                </div>

                <div className="form-group">
                    <label className="control-label">Innehåll</label>
                    <textarea rows={3} className="form-control input-sm" onChange={form.handleChange} onBlur={form.handleBlur} value={form.values.message} name="message"></textarea>
                    {form.errors.message && <div id="feedback">{form.errors.message}</div>}
                </div>

                <div className={styles.splitGroup}>
                    <div className="checkbox">
                        <label>
                            <input type="checkbox" checked={form.values.publish} onChange={form.handleChange} name="publish"/>
                            Visa på Troman Politiker
                        </label>
                    </div>
                    <div>
                        {
                            notificationTimestamp ? (
                                <div>Notis skickad {notificationTimestamp.toLocaleString('sv-SE')}</div>
                            ) : (
                                <div className="checkbox">
                                    <label>
                                        <input type="checkbox" checked={form.values.notify} onChange={form.handleChange} name="notify"/>
                                        Skicka notis till deltagare
                                    </label>
                                </div>
                            )
                        }
                    </div>
                </div>
                
                <div className={styles.splitGroup}>
                    <div className={styles.controls}>
                        { props.onDelete && (<TromanButton variant={ButtonVariants.Danger} text="Radera" icon={Icons.Delete} onClick={props.onDelete}/>) }
                    </div>
                    <div className={styles.controls}>
                        <TromanButton onClick={props.onCancel} text="Avbryt"/>
                        <TromanButton type="submit" variant={ButtonVariants.Primary} text={form.values.notify ? "Spara & Skicka" : "Spara"}/>
                    </div>
                </div>
        </form>
      </div>
    )
};